import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { ROUTES } from "../../../utils/routes";
import { getAll, create } from "../../../utils/requests/dynamicReq";
import Axios from "axios";

import { paths } from "../../../utils/paths";
import * as XLSX from "xlsx";

export const AllPublications = () => {
  const history = useHistory();

  
  const { isAdmin } = useSelector(({ user }) => user);

  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { PUBLICATIONS } = paths;
  const [publications, setPublications] = useState([]);
  const [displayPublications, setDisplayPublications] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = async () => {
    try {

      const response = await getAll(PUBLICATIONS, source);
      if (isMountedRef.current) {
        setDisplayPublications(response);
        setPublications(response);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("HTTP call cancelled");
    }
  };

  const searchBar = (value) => {
    setDisplayPublications(
      publications.filter(({ title }) =>
        title?.toLowerCase().includes(value.toLowerCase())
      )
    );
    !value && setDisplayPublications(publications);
  };

  
  const handleSync = async () => {
   
    const result = await Swal.fire({
      title: "¿Iniciar carga de publicaciones?",
      text: "Este proceso puede tardar varios minutos. Por favor, NO cierres ni actualices la página mientras se está ejecutando.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0073B5",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, sincronizar",
      cancelButtonText: "Cancelar",
    });

   
    if (result.isConfirmed) {
      Swal.fire({
        title: "Cargando publicaciones",
        text: "Sincronizando, por favor espere...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
      
        await create(`${PUBLICATIONS}/sync-orcid`, {}, source);

       
        await loadData();

        Swal.fire({
          icon: "success",
          title: "¡Sincronización exitosa!",
          text: "Las publicaciones se han actualizado correctamente.",
          confirmButtonColor: "#0073B5",
        });
      } catch (error) {
        console.error("Error en la sincronización manual:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ocurrió un error al intentar sincronizar las publicaciones.",
          confirmButtonColor: "#0073B5",
        });
      }
    }
  };

  const downloadExcel = () => {
    const data = publications.map((p) => ({
      Título: p.title || "",
      URL: p.url || "",
      Revista: p.journal || "",
      Editorial: p.publisher || "",
      Volumen: p.volume || "",
      Número: p.number || "",
      Páginas: p.pages || "",
      Autores: p.authors || "",
      Resumen: p.summary || "",
      Año: p.year || "",
      Mes: p.month || "",
      Día: p.day || "",
      Oculto: p.isHidden ? "Sí" : "No",
      ISBN: p.isbn || "",
      Subtítulo: p.subtitle || "",
      Citación: p.citation || "",
      "Descripción Citación": p.citationDescription || "",
      DOI: p.doi || "",
      Localización: p.location || "",
      Tipo: p.type || "",
      Estado: p.status || "",
      "Producción Personal": p.produccionPersonal ? "Sí" : "No",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Publicaciones");

    XLSX.writeFile(workbook, "publicaciones.xlsx");
  };

  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col d-flex justify-content-between">
          <div>
            <h3>Todas las publicaciones</h3>
          </div>
          <div>
            <button
              className="baseBtn"
              onClick={() => history.push(ROUTES.Publications.create)}
            >
              + Añadir
            </button>

            {isAdmin && (
              <button className="baseBtn ml-2" onClick={handleSync}>
                Cargar publicaciones
              </button>
            )}

            <button className="baseBtn ml-2" onClick={downloadExcel}>
              Descargar Excel
            </button>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <Form.Group as={Col}>
          <InputGroup className="shadow">
            <InputGroup.Prepend>
              <InputGroup.Text className="inputGroup ">
                <FontAwesomeIcon color="#0073B5" icon={faSearch} />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              type="text"
              placeholder="Buscar..."
              className="form-control"
              onChange={({ target: { value } }) => searchBar(value)}
            />
          </InputGroup>
        </Form.Group>
      </div>
      <div className="row">
        <div className="col-12 ">
          <table className="table table-hover">
            <tbody>
              {displayPublications?.map((a) => (
                <tr
                  key={a.id}
                  className="pointer"
                  onClick={() =>
                    history.push(`${ROUTES.Publications.all}/${a.id}`)
                  }
                >
                  <td>{a.title}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {isLoading && (
            <div className="d-flex justify-content-center">
              <div className="spinner-border mt-5" role="status" />
            </div>
          )}

          {!publications.length && !isLoading && (
            <div className="d-flex justify-content-center mb-3">
              <h5>-No existen publicaciones-</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
